module.exports = __webpack_public_path__ + "static/786fa16eec9de3fb2ce864ba0c62296ef054f9c17c620d69aae6726a50f4874c-a1f20b9e62a0979fab58bfd094a265f9.png";